import { SubscriptionBookingStatus } from '@platform-frontend/checkout-drop-in';
import { CanceledStatus } from './canceled-status';
import { ExpiredStatus } from './expired-status';

export type FullSubscriptionBookingStatus = SubscriptionBookingStatus | ExpiredStatus | CanceledStatus;
